import JobOffer from "./job-offer";
import IFilterOptions from "./types/filter-options";
import Filter from "./filter";

function findJobOffers(): JobOffer[] {
  const elements = document.getElementsByClassName("job-offers-list-item");

  const offers: JobOffer[] = [];
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    if (!(element instanceof HTMLElement)) {
      continue;
    }

    offers.push(JobOffer.parse(element));
  }

  return offers;
}

let pagingButton: HTMLButtonElement | null = null;

function initializePaging(offers: JobOffer[]): void {
  if (!offers.length) return;

  let maxIndex = 6;

  function updatePaging(): void {
    for (let i = 0; i <= maxIndex; i++) {
      const offer = offers[i];
      offer.show();
    }

    for (let i = maxIndex + 1; i < offers.length; i++) {
      const offer = offers[i];
      offer.hide();
    }
  }

  function buildButton(): void {
    const parent = document.getElementsByClassName("job-offers-list")[0];
    if (parent == null) {
      return;
    }

    const button = document.createElement("button") as HTMLButtonElement;

    button.textContent = "Weitere Stellenangebote →";
    button.addEventListener("click", () => {
      maxIndex += 7;
      if (maxIndex >= offers.length - 1) {
        maxIndex = offers.length - 1;
        button.remove();
      }
      requestAnimationFrame(updatePaging);
    });
    parent.appendChild(button);
    pagingButton = button;
  }

  requestAnimationFrame(() => {
    updatePaging();
    buildButton();
  });
}

function extractFilterOptions(offers: JobOffer[]): IFilterOptions {
  const options = { departments: new Set<string>(), places: new Set<string>(), contracts: new Set<string>(), terminability: new Set<string>() };

  offers.forEach(offer => {
    if (offer.department) {
      options.departments.add(offer.department);
    }

    if (offer.contract) {
      options.contracts.add(offer.contract);
    }

    if (offer.terminability) {
      options.terminability.add(offer.terminability);
    }

    offer.places.forEach(place => options.places.add(place));
  });

  return options;
}

function findFilterContainer(): HTMLElement {
  const e = document.getElementsByClassName("fom-job-filter");
  if (e.length <= 0 || !(e[0] instanceof HTMLElement))
    throw new Error("no filter container");
  return e[0];
}

function createInputContainer(): HTMLElement {
  const e = document.createElement("div");
  e.className = "fom-job-filter-container col-12 col-lg-6";
  return e;
}

function createInput(text: string): HTMLSelectElement {
  const e = document.createElement("select");
  e.className = "fom-job-filter-input";

  const o = document.createElement("option");
  o.textContent = text;

  e.appendChild(o);

  const iC = createInputContainer();
  iC.appendChild(e);

  const fC = findFilterContainer();
  fC.appendChild(iC);

  return e;
}

function showTerminability(): boolean {
  return document.body.id === 'page-747';
}

try {
  const offers = findJobOffers();
  console.debug("job offers", offers);

  initializePaging(offers);

  const filterOptions = extractFilterOptions(offers);
  console.debug("filter options", filterOptions);

  const filter = new Filter(
    {
      department: createInput("Stellenart"),
      place: createInput("Ort"),
      terminability: showTerminability() ? createInput("Fachgebiet") : undefined
    },
    offers
  );
  filter.onchange = (): void => {
    if (pagingButton != null) {
      pagingButton.remove();
      pagingButton = null;
    }
  };
  filter.initialize(extractFilterOptions(offers));
  console.debug("filter", filter);
} catch (e) {
  console.debug(e);
}
